import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import Header from "../home/header";
import Login from "../home/login_form";
import feature from "../../img/suppliers.svg";
import Loading from "../home/Loading";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";


const SupplierEditForm = props => {
  let navigate = useNavigate();
  var location = useLocation();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );

  const { id } = useParams();
  const sup = location.state
  const [ feedback, setFeedback ] = useState( "" );
  const [ isLoading, setIsLoading ] = useState( false );
  const [ data, setData ] = useState( sup );

  const apiClient = new ApiClient( loginState.accessToken );



  const saveSupplier = async ( supplier ) => {
    setIsLoading( true );
    try {
      await apiClient.patch( `suppliers/${id}`, supplier );
      navigate( "/suppliers", { replace: true } );
    }
    catch ( e ) {
      setFeedback( "Oops! Something went wrong" );
    }
    setIsLoading( false );
  }
  const handleChange = ( e ) => {
    let target = e.target;
    let value = target.value;
    let nd = { ...data };
    switch ( target.id ) {
      case "name":
        nd.companyName = value;
        break;
      case "contact":
        nd.contactName = value;
        break;
      case "country":
        nd.country = value;
        break;
      case "address":
        nd.address = value;
        break;
      case "email":
        nd.contactEmail = value;
        break;
      case "phone":
        nd.contactPhone = value;
        break;
      default:
        break;
    }
    setData( nd );
  }
  const handleSubmit = ( e ) => {
    e.preventDefault();
    let name = document.getElementById( "name" ).value;
    let country = document.getElementById( "country" ).value;
    let phone = document.getElementById( "phone" ).value;
    let contact_person = document.getElementById( "contact" ).value;
    let email = document.getElementById( "email" ).value;
    let address = document.getElementById( "address" ).value;
    let sup = { companyName: name, country: country, contactEmail: email, contactPhone: phone, address: address, contactName: contact_person };
    saveSupplier( sup );
  }

  if ( loginState ) {
    return ( <>
      <Header auth={loginState} />
      <section className="container mx-auto mt-8">
        {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div> : null}

        <div className="rounded-xl border border-gray-200 bg-white shadow-md p-4 md:p-6">
          <div className="flex items-center justify-between mb-5">
            <div>
              <p className="text-sm uppercase tracking-wide text-gray-500">Supplier Setup</p>
              <p className="text-2xl font-semibold text-gray-800">Edit Supplier</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            <div className="md:col-span-1 rounded-xl border border-gray-200 bg-gray-50 p-4 text-center">
              <img src={feature} alt="Supplier feature" className="h-36 w-36 rounded-xl object-cover border-2 border-primary-200 mx-auto" />
              <p className="text-sm text-gray-500 mt-3">Supplier Profile</p>
            </div>
            <div className="md:col-span-2">
              <form id="new_supplier_form"
                className="w-full"
                method="post" onSubmit={handleSubmit}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="name" className="text-sm text-gray-600">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Company name" defaultValue={data.companyName} onChange={( e ) => handleChange( e )}
                    />
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="contact" className="text-sm text-gray-600">Contact Person</label>
                    <input
                      type="text"
                      className="form-control"
                      id="contact"
                      name="contact"
                      placeholder="Contact Person" defaultValue={data.contactName} onChange={( e ) => handleChange( e )}
                    />
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="phone" className="text-sm text-gray-600">Phone Number</label>
                    <input
                      type="number"
                      className="form-control"
                      id="phone"
                      name="phone"
                      placeholder="Phone Number" defaultValue={data.contactPhone} onChange={( e ) => handleChange( e )}
                    />
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="country" className="text-sm text-gray-600">Country</label>
                    <select
                      className="form-control"
                      id="country"
                      name="country" defaultValue={data.country} onChange={( e ) => handleChange( e )}>
                      {UTILS.COUNTRIES.map( c => {
                        return <option key={c}>{c}</option>
                      } )}
                    </select>
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="address" className="text-sm text-gray-600">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      name="address"
                      placeholder="address" defaultValue={data.address} onChange={( e ) => handleChange( e )}
                    />
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="email" className="text-sm text-gray-600">E-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="E-mail" defaultValue={data.contactEmail} onChange={( e ) => handleChange( e )}
                    />
                  </div>
                </div>

                <div className="form-group mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    {isLoading ? <Loading /> :
                      <input
                        type="submit"
                        className="form-control bg-success"
                        id="btnSubmit"
                        name="btnSubmit"
                        value="SUBMIT"
                      />}
                  </div>
                  <div>
                    <input onClick={() => { navigate( "/suppliers", { replace: true } ) }}
                      type="button"
                      className="form-control"
                      value="Cancel"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </> )
  }
  return <Login target="/suppliers" />
}
export default SupplierEditForm;